export default __webpack_public_path__ + "static/media/kitchen2-1440w.09901c01.avif";